import { MealyModelType } from '../mealyModelType';
import DoorSystem from './DoorSystem.svelte';
export const mealyModelDoorSystem = {
    component: DoorSystem,
    type: MealyModelType.DOORSYSTEM,
    alphabet: ['1', '2', '3'],
    outputs: ['XXX', 'XXO', 'XOX', 'XOO', 'OXX', 'OXO', 'OOX', 'OOO'],
};
